import { DropdownBase } from "./DropdownBase";
import { Divider } from "./Divider";
import { Label } from "./Label";
import { Menu } from "./Menu";
import { MenuItem } from "./MenuItem";
import { SubMenu } from "./SubMenu";

export type { DropdownProps, DropdownPosition } from "./types";

type DropdownComponent = typeof DropdownBase & {
  displayName?: string;
  Menu: typeof Menu;
  MenuItem: typeof MenuItem;
  Divider: typeof Divider;
  Label: typeof Label;
  SubMenu: typeof SubMenu;
};

const DropdownMenu = DropdownBase as DropdownComponent;
DropdownMenu.displayName = "DropdownMenu";
DropdownMenu.Menu = Menu;
DropdownMenu.MenuItem = MenuItem;
DropdownMenu.Divider = Divider;
DropdownMenu.Label = Label;
DropdownMenu.SubMenu = SubMenu;

export { DropdownMenu };
